import { IonContent, IonIcon, IonPage } from '@ionic/react'
import { chevronForwardOutline } from 'ionicons/icons'
import moment from 'moment-timezone'
import React from 'react'
import styled from 'styled-components'
import { ResultBuyProduct } from '../../../../common'
import { Chip, CustomSpacer, FooterButtons, StyleIonHeader, TextStyle } from '../../../../components'
import { DivideLine } from '../../../../components/atoms/divide'

type Props = {
  resultBuyProduct: ResultBuyProduct
  onDismiss: () => void
}

export const SaleDoneModal: React.FC<Props> = ({ onDismiss, resultBuyProduct }) => {
  const onVerifyTx = () => {
    window.open(`https://baobab.scope.klaytn.com/tx/${resultBuyProduct.transaction.txId}`, '_blank')?.focus()
  }

  const onDownloadContract = async () => {
    await window.location.assign(
      `${process.env.REACT_APP_STO_API}/purchase/contract/${resultBuyProduct.orderSequence}?embed=false`,
    )
  }

  const onDismissModal = () => {
    setTimeout(() => {
      location.reload()
    }, 300)
  }

  return (
    <IonPage>
      <StyleIonHeader type={'MODAL'} title={'구매 확인서'} onDismiss={onDismiss} />
      <IonContent>
        <SectionContainer>
          <TextStyle type="b_24">{'조각 구매 확인서'}</TextStyle>
        </SectionContainer>
        <CustomSpacer spacing="8px" />
        <ImgWrap>
          <img
            src={resultBuyProduct.transaction.certificateImgUrl}
            alt={resultBuyProduct.product.name}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = '/img/thumbnail.svg'
            }}
          />
        </ImgWrap>
        <CustomSpacer spacing="8px" />
        <SectionContainer>
          <TextStyle type="b_16">총 거래 정보 </TextStyle>
          <CustomSpacer spacing="16px" />
          <BetweenWrap>
            <TextStyle type="r_13" color="gray400">
              거래일시
            </TextStyle>
            <TextStyle type="r_13">{`${moment(new Date(resultBuyProduct.createdDate)).format(
              'YYYY.MM.DD HH:MM:SS',
            )}`}</TextStyle>
          </BetweenWrap>
          <DivideWrap>
            <DivideLine />
          </DivideWrap>
          <BetweenWrap>
            <TextStyle type="r_13" color="gray400">
              작품명
            </TextStyle>
            <TextStyle type="r_13">{resultBuyProduct.product.name}</TextStyle>
          </BetweenWrap>
          <BetweenWrap>
            <TextStyle type="r_13" color="gray400">
              작가명
            </TextStyle>
            <TextStyle type="r_13">{resultBuyProduct.product.artist}</TextStyle>
          </BetweenWrap>
          <DivideWrap>
            <DivideLine />
          </DivideWrap>
          <BetweenWrap>
            <TextStyle type="r_13" color="gray400">
              총 금액
            </TextStyle>
            <TextStyle type="r_13">
              {`${(resultBuyProduct.count * resultBuyProduct.cost).toLocaleString('ko-kr')} 원`}
            </TextStyle>
          </BetweenWrap>
          <DivideWrap>
            <DivideLine />
          </DivideWrap>
          <BetweenWrap onClick={onVerifyTx}>
            <TextStyle type="r_13" color="gray400">
              트랜잭션 정보
            </TextStyle>
            <TxInfoContainer>
              <div className="tx_link">{resultBuyProduct.transaction.txId}</div>
              <IonIcon color="medium" icon={chevronForwardOutline}></IonIcon>
            </TxInfoContainer>
          </BetweenWrap>
          <DivideWrap>
            <DivideLine />
          </DivideWrap>
          <BetweenWrap2>
            <TextStyle type="r_13" color="gray400">
              구매계약서
            </TextStyle>
            <TxInfoContainer onClick={onDownloadContract}>
              <Chip type="blue">다운</Chip>
            </TxInfoContainer>
          </BetweenWrap2>
        </SectionContainer>
        <MsgContainer>
          <TextStyle type="r_13" color="gray400">
            블록체인에 기록된 변조 불가능한 거래내역입니다.
          </TextStyle>
        </MsgContainer>
        <CustomSpacer spacing="30px" />
      </IonContent>
      <FooterButtons
        button={{
          color: 'dark',
          text: '닫기',
          onClick: onDismissModal,
        }}
      />
    </IonPage>
  )
}

const ImgWrap = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  img {
    max-width: 340px;
    height: 400px;
    object-fit: contains;
    border-radius: 10px;
    box-shadow: 3px 1px 5px 0px;
  }
`

const SectionContainer = styled.div`
  padding: 20px;
`

const BetweenWrap = styled.div`
  display: flex;
  justify-content: space-between;
`

const BetweenWrap2 = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`

const DivideWrap = styled.div`
  padding: 16px 0;
`

const TxInfoContainer = styled.div`
  max-width: 140px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  .tx_link {
    color: var(--ion-color-secondary_main);
    text-decoration: underline;
    text-decoration-color: var(--ion-color-secondary_main);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ion-icon {
    min-width: 16px;
  }
`

const MsgContainer = styled.div`
  width: 100%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`
